// The demo book lives in @vero/platform (packages/platform/src/demo-seed.ts) so the platform server can seed the
// hosted reviewer account with the same data; the app re-exports it.
export { seedDemo, type DemoProfile, type SeedOptions } from '@vero/platform/demo-seed';
